import { YesNoIndicators } from '../../../global/models/api-model';
import { MyCpgPodsSettings, MyCpgPodsState } from '../mycpg-pod-models';

export function hasNoPlan(podsState) {
	return podsState?.pods?.annuity_data?.show_pod === YesNoIndicators.No &&
		podsState?.pods?.db_data?.show_pod === YesNoIndicators.No &&
		podsState?.pods?.dc_data?.show_pod === YesNoIndicators.No &&
		podsState?.pods?.dental_data?.show_pod === YesNoIndicators.No &&
		podsState?.pods?.medical_data?.show_pod === YesNoIndicators.No &&
		podsState?.pods?.life_data?.show_pod === YesNoIndicators.No &&
		podsState?.pods?.disability_data?.disability_pod === YesNoIndicators.No &&
		podsState?.pods?.rsvp_data?.show_pod === YesNoIndicators.No;
}

export function GetBottomSectionMessage(settings: MyCpgPodsSettings, podsState: MyCpgPodsState) {
	const employmentHistory = podsState?.pods?.employment_history_data?.data;
	if (
		employmentHistory?.active_cpg_employee === YesNoIndicators.Yes &&
		employmentHistory?.active_church_employee === YesNoIndicators.No &&
		employmentHistory?.former_church_employee === YesNoIndicators.No) {
		return settings?.activeCpgEmployeeOnlyMessage;
	}
	if (
		employmentHistory?.active_cpg_employee === YesNoIndicators.Yes &&
		employmentHistory?.active_church_employee === YesNoIndicators.Yes) {
		return settings?.activeCpgAndChurchEmployeeMessage;
	}
	if (
		employmentHistory?.former_cpg_employee === YesNoIndicators.Yes &&
		employmentHistory?.active_church_employee === YesNoIndicators.No &&
		employmentHistory?.former_church_employee === YesNoIndicators.No) {
		return settings?.formerCpgEmployeeOnlyMessage;
	}
	if (
		employmentHistory?.former_cpg_employee === YesNoIndicators.Yes && (
			employmentHistory?.active_church_employee === YesNoIndicators.Yes ||
			employmentHistory?.former_church_employee === YesNoIndicators.Yes)) {
		return settings?.formerCpgEmployeeActiveChurchOnlyMessage;
	}

	return null;
}